import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./login.css";

export default function Login() {
  const [data, setData] = useState({ username: "", password: "" });
  const [error, setError] = useState("");
  const navigate = useNavigate();

  // ✅ ADD THESE TWO LINES
  const API_URL = process.env.REACT_APP_API_URL;
  const DASHBOARD_URL = process.env.REACT_APP_ADMIN_DASHBOARD;

  // Handle form submit
  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const res = await axios.post(
        `${API_URL}/api/auth/login`,
        data
      );

      // Save token
      localStorage.setItem("token", res.data.token);

      // ✅ Dynamic redirect
      navigate(DASHBOARD_URL);
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || "Login failed");
    }
  };

  return (
    <div className="adminLogin-wrapper-unique">
      <div className="adminLogin-card-unique">
        <h2 className="adminLogin-title-unique">Admin Login</h2>

        <form className="adminLogin-form-unique" onSubmit={handleLogin}>
          <label className="adminLogin-label-unique">Username</label>
          <input
            type="text"
            className="adminLogin-input-unique"
            placeholder="Enter username"
            value={data.username}
            onChange={(e) =>
              setData({ ...data, username: e.target.value })
            }
            required
          />

          <label className="adminLogin-label-unique">Password</label>
          <input
            type="password"
            className="adminLogin-input-unique"
            placeholder="Enter password"
            value={data.password}
            onChange={(e) =>
              setData({ ...data, password: e.target.value })
            }
            required
          />

          <button className="adminLogin-btn-unique" type="submit">
            Login
          </button>

          {error && (
            <p style={{ color: "red", marginTop: "10px" }}>
              {error}
            </p>
          )}
        </form>
      </div>
    </div>
  );
}
